import { gql } from "@apollo/client";

const TOURNAMENTS_BY_TEAMS = gql`
  query fetchTournamentsByTeamId($teamId: Int!, $relations: [String!]) {
    fetchTournamentsByTeamId(teamId: $teamId, relations: $relations) {
      id
      title
      type
      logo
      country
      city
      tournamentCategory {
        id
      }
      startDate
      entryDeadline
      status

      endDate
      league {
        league {
          type
          sports {
            title
          }
        }
      }
    }
  }
`;

export default TOURNAMENTS_BY_TEAMS;
